import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { GetEnumValuesDto, SmsAggregator } from 'src/app/core/api/models';

@Component({
    selector: 'app-doughnut-chart-sent-count-seasons-compare-statistics',
    templateUrl: './doughnut-chart-sent-count-seasons-compare-statistics.component.html',
    standalone: false
})
export class DoughnutChartSentCountSeasonsCompareStatisticsComponent
  implements OnInit
{
  @Input() model: any[] = [];
  @Input() chartId: string = '';
  @Input() enumValues: GetEnumValuesDto[];

  labels: string[] = [];
  colors: string[] = [];
  data: number[] = [];
  title: string = '';

  get StatisticsOperators() {
    return SmsAggregator;
  }
  constructor(private translateService: TranslateService) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['model']) {
      if (this.model?.length) {
        this.setData();
      }
    }
  }

  setData() {
    const styles = getComputedStyle(document.documentElement);
    this.data = [];
    this.labels = [];
    this.colors = [
      styles.getPropertyValue('--color-danger'),
      styles.getPropertyValue('--color-blue'),
    ];
    this.aggregateSmsParts().forEach((item) => {
      this.labels.push(
        item.label +
          ' (' +
          item.partCount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
          ')'
      );
      this.data.push(+item.partCount);
    });
  }

  aggregateSmsParts() {
    const yearAggregation = {};

    this.model.forEach((entry) => {
      const label = entry.label;

      // در صورت عدم وجود، لیبل را به صورت تجمیع شروع میکنیم
      if (!yearAggregation[label]) {
        yearAggregation[label] = 0;
      }

      // مجموع اس ام اس پارت ها برای هر آیتم در آرایه آیتم ها
      entry.items.forEach((item) => {
        yearAggregation[label] += item.partCount;
      });
    });

    // نتیجه را به شکل یک آرایه برمیگردانیم
    return Object.entries(yearAggregation).map(([label, count]) => ({
      label,
      partCount: count,
    }));
  }
}
